'use strict';
export function init() {

    //Set up tab indices for menu so items are not focusable by keyed navigation unless menu is open
    const MENU_SELECTOR = '.global-navigation';
    const TOOLBAR_SELECTOR = '.global-header__toolbar';
    const LOGO_SELECTOR = '.global-header__logo';
    
    const menu = document.querySelector(MENU_SELECTOR);
    const logo = document.querySelector(LOGO_SELECTOR);
    const toolbar = document.querySelector(TOOLBAR_SELECTOR);
    const globalHeaderButton = document.querySelector('.global-header__menu');
    
    const focusableElements = getFocusableElements();
    
    



    // Function to get all focusable elements inside the menu
    function getFocusableElements() {
        return [logo, globalHeaderButton, ...toolbar.querySelectorAll('a'),...menu.querySelectorAll(
            'a, button, input, textarea, select, details, [tabindex], [role="button"]'
        )].filter(el => !el.hasAttribute('disabled'));
    }

    // Function to trap focus within the menu
    function trapFocus(event) {
        const firstFocusable = focusableElements[0];
        const lastFocusable = focusableElements[focusableElements.length - 1];

        if (event.key === 'Tab') {
            if (event.shiftKey) { // If Shift + Tab is pressed (backward tabbing)
                if (document.activeElement === firstFocusable) {
                    lastFocusable.focus(); // Move focus to the last focusable element
                    event.preventDefault();
                }
            } else { // Regular Tab key (forward tabbing)
                if (document.activeElement === lastFocusable) {
                    firstFocusable.focus(); // Move focus to the first focusable element
                    event.preventDefault();
                }
            }
        }
    }

    // Add event listener to trap focus when menu is open
    document.addEventListener('keydown', trapFocus);

    const addTabIndices = elements => {
        elements.forEach((element, index) => {
              element.tabIndex = 0;
        });
    };
      
    const removeTabIndices = elements => {
        elements.forEach(element => {
            // Skip <a> and <button> elements inside .global-header__toolbar
            if (element.closest('.global-header__toolbar') && (element.tagName === 'A' || element.tagName === 'BUTTON')) {
                return;
            }
            element.tabIndex = -1;
        });
    };
      
      removeTabIndices(focusableElements);
      
    // Add tab indices to focusable elements when menu is open

    globalHeaderButton.addEventListener('click', () => {
        if (menu.classList.contains('is-toggled')) {
            removeTabIndices(focusableElements);
        } else {
        addTabIndices(focusableElements);
        }
    });
     
}



